<template lang="html">
  <div>
    <d-button-group class="buttons">
      <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
        <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
      </d-button>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_PUZZLE_ } from '_modules/puzzle/components/PuzzleModel';

export default {
  name: 'puzzle-buttons',
  props: {
    puzzle: {
      type: Object,
      default: null,
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_PUZZLE_, this.puzzle);
    },
  },
  mounted() {},
};
</script>
